import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Register from '../views/Register.vue'
// import Camera from '../views/Camera.vue'
// import SendCertificate from '../views/SendCertificate.vue'
// import Viewcertificate from '../views/Viewcertificate.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    // {
    //     path: '/register',
    //     name: 'register',
    //     component: Register,
    //     meta: {
    //         title: 'ดาวน์โหลดหนังสือรับรองการชำระเบี้ยประกันเพื่อใช้หักลดหย่อนภาษี – เจนเนอราลี่'
    //     }
    // }
    // , {
    //     path: '/camera',
    //     name: 'camera',
    //     component: Camera
    // }
    // , {
    //     path: '/sendcertificate',
    //     name: 'sendcertificate',
    //     component: SendCertificate
    // }
    // , {
    //     path: '/viewcertificate',
    //     name: 'viewcertificate',
    //     component: Viewcertificate
    // }
]
const router = new VueRouter({
    routes,
    mode: 'history'
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) document.title = to.meta.title
    next()
})

export default router